import React from 'react';

function Header() {
    return (
        <header>
            <nav className='header__nav'>
                <div className='header__logo'>
                    <h4>Sushiman</h4>
                    <div className='header__logo-overlay'></div>
                </div>

                <ul className='header__menu'>
                    <li>
                        <a href='#menu'>Menu</a>
                    </li>
                    <li>
                        <a href='#food'>Food</a>
                    </li>
                    <li>
                        <a href='#services'>Services</a>
                    </li>
                    <li>
                        <a href='#about-us'>About Us</a>
                    </li>
                    <li>
                        <img
                            src={process.env.PUBLIC_URL + '/assets/search.svg'}
                            alt='search icon'
                        />
                    </li>
                </ul>

                <ul className='header__menu-mobile'>
                    <li>
                        <img
                            src={process.env.PUBLIC_URL + '/assets/menu.png'}
                            sxrc='assets/menu.svg'
                            alt='menu'
                        />
                    </li>
                </ul>
            </nav>
        </header>
    );
}

export default Header;
